import parse from 'url-parse'

// 判断 url 是否是安全链接
export const isSafeUrl = (url) => {
  const targetHost = parse(decodeURIComponent(url)).host
  return /msport\.com/.test(targetHost)
}

const domainWhiteList = ['spribegaming.com', 'spribe.io', 'launcher.server1.ih.testenv.io', 'fh8labs.com', 'ssgportal.com']

export const isDomainWhitelisted = (gameUrl = '') => {
  if (!gameUrl) return false
  const gameUrlDomain = parse(gameUrl).host ?? ''
  return domainWhiteList.some((domain) => {
    const reg = new RegExp(`^(?:[\\w-]+\\.)*${domain}$`, 'gi')
    return reg.test(gameUrlDomain)
  })
}

// 清理 html 中的 script, style, link, meta 标签
export const cleanHtml = (html = '') => {
  return html
    .replace(/<script[^>]*>[^<]*<\/script>/g, '')
    .replace(/<style[^>]*>[^<]*<\/style>/g, '')
    .replace(/<link[^>]*>/g, '')
    .replace(/<meta[^>]*>/g, '')
}
